import { graphql } from '@/generated/gql';

export const INTAKE_EXTENDED_LINE_ITEMS_MUTATION = graphql(`
  mutation IntakeExtendedLineItems($data: SvbrgExtendedLineItemsCheckInput!) {
    sevenbridges {
      chatSession {
        extendedLineItemsCheck {
          checkLineItems(data: $data) {
            chatSessionId
            checks {
              id
              chatSessionId
              position
              title
              description
              pricePerUnit
              quantity
              earlyDeliveryAt
              lateDeliveryAt
              checkResults {
                catalogueItems {
                  currency
                  deliveryTime
                  description
                  id
                  inStock
                  manufacturer
                  name
                  previewImage
                  price
                  punchoutUrl
                  shippingCosts
                }
                contractItems {
                  createdAtTimestamp
                  id
                  contract {
                    # eslint-disable-next-line @graphql-eslint/selection-set-depth
                    id
                    # eslint-disable-next-line @graphql-eslint/selection-set-depth
                    currency
                    # eslint-disable-next-line @graphql-eslint/selection-set-depth
                    plannedValueFloat
                    # eslint-disable-next-line @graphql-eslint/selection-set-depth
                    supplierId
                  }
                  plannedQuantityFloat
                  pricePerUnitFloat
                  title
                }
              }
            }
          }
        }
      }
    }
  }
`);

export const INTAKE_EXTENDED_LINE_ITEMS_NEXT_MUTATION = graphql(`
  mutation IntakeExtendedLineItemsNext($data: SvbrgExtendedLineItemsCheckNextInput!) {
    sevenbridges {
      chatSession {
        extendedLineItemsCheck {
          next(data: $data) {
            id
          }
        }
      }
    }
  }
`);
